import { errorLogger } from 'utils/config/firebase/logs';
import { deleteHtmlFromString } from './htmlParser';

interface OnCopyType {
    format?: string;
    onCopy?: () => void;
    isSelection?: boolean;
}

export function onCopyValue(value: string, options?: OnCopyType) {
    const debug = false;
    let range,
        mark,
        selection,
        success = false;
    if (!options) {
        options = {};
    }
    try {
        range = document.createRange();
        selection = document.getSelection();

        if (!options?.isSelection) {
            selection?.removeAllRanges();

            mark = document.createElement('span');
            mark.textContent = value;
            // avoid screen readers from reading out loud the text
            mark.ariaHidden = 'true';
            // reset user styles for span element
            mark.style.all = 'unset';
            // prevents scrolling to the end of the page
            mark.style.position = 'fixed';
            mark.style.top = '0';
            mark.style.clip = 'rect(0, 0, 0, 0)';
            // used to preserve spaces and line breaks
            mark.style.whiteSpace = 'pre';
            // do not inherit user-select (it may be `none`)
            mark.style.webkitUserSelect = 'text';
            mark.style.userSelect = 'text';
            mark.addEventListener('copy', function (e) {
                e.stopPropagation();
                e.preventDefault();
                if (typeof e.clipboardData === 'undefined') {
                    // IE 11
                    if (debug) {
                        console.warn('unable to use e.clipboardData');
                        console.warn('trying IE specific stuff');
                    }
                } else {
                    // all other browsers
                    e?.clipboardData?.clearData();
                    e?.clipboardData?.setData('text/plain', deleteHtmlFromString(value));
                    e?.clipboardData?.setData('text/html', value);
                }
            });

            document.body.appendChild(mark);

            range.selectNodeContents(mark);
        }

        selection?.addRange(range);
        const successful = document.execCommand('copy');
        if (!successful) {
            throw new Error('copy command was unsuccessful');
        }
        if (options?.onCopy) {
            options.onCopy();
        }
        success = true;
    } catch (error) {
        if (error instanceof Error) {
            errorLogger.critical(error?.message, 'onCopyValue');
        }
        console.log(error);
    } finally {
        if (selection) {
            try {
                if (typeof selection.removeRange == 'function' && range) {
                    selection.removeRange(range);
                }
            } catch {
                selection.removeAllRanges();
            }
        }
        if (mark) {
            document.body.removeChild(mark);
        }
    }

    return success;
}
